export function sanitize(price) {
    price = price.replace(/[^0-9]/g, '');
    price = parseFloat(price);

    return price;
}

export function format(price) {
    const formatter = new Intl.NumberFormat('es-ES', {
        style: 'currency',
        currency: 'EUR',
        useGrouping: 'always',
    });

    return formatter.format(price / 100);
}
